export default class Event {
    constructor(event, params) {
        let defaultParams = {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };

        params = params || defaultParams;
        let evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
}
